import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Link,
  Rating,
  Typography,
} from '@mui/material';
import React from 'react';
import useAuthToken from '../../../hooks/getUserData';
import { ProductProviderOptions } from '../../../staticData/tableHead';
import AddProductLinks from './AddProductProvider';
import DeleteProductProvider from './DeleteProductProvider';
import EditProductLinks from './EditProductProvider';

const getProviderLabel = (providerValue) => {
  const provider = ProductProviderOptions.find(
    (p) => p.value === providerValue
  );
  return provider ? provider.label : providerValue;
};

const ProductProvider = ({
  product,
  fetchProduct,
  setMessage,
  setSnackbarOpen,
}) => {
  const token = useAuthToken();

  const openURL = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Card>
      <CardHeader
        title="Links"
        sx={{ paddingBottom: 0 }}
        action={
          <AddProductLinks
            product={product}
            fetchData={fetchProduct}
            token={token}
            setMessage={setMessage}
            setSnackbarOpen={setSnackbarOpen}
          />
        }
      />
      <CardContent>
        {product.providers.length > 0 ? (
          product.providers.map((detail, index) => (
            <Box
              key={index}
              style={{
                margin: '16px 0',
                padding: '16px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                    {detail.icon && (
                      <img
                        src={detail.icon}
                        alt={detail.provider_name}
                        width="25"
                        height="25"
                        style={{ marginRight: '8px' }}
                      />
                    )}
                    {getProviderLabel(detail.provider_name)}
                  </Typography>
                  {detail.url && (
                    <Button
                      variant="text"
                      onClick={() => openURL(detail.url)}
                      endIcon={<OpenInNewIcon />}>
                      Open URL
                    </Button>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  {detail.price !== null && (
                    <Typography variant="subtitle1">{`$${parseFloat(
                      detail.price
                    ).toLocaleString('en-US', {
                      maximumFractionDigits: 2,
                    })}`}</Typography>
                  )}

                  {detail.review_url ? (
                    <Grid container justifyContent="center" spacing={1}>
                      {detail.rating !== null && (
                        <Grid item>
                          <Rating
                            name={`rating-${index}`}
                            value={detail.rating}
                            precision={0.1}
                            readOnly
                          />
                        </Grid>
                      )}
                      {detail?.review_count !== null && (
                        <Grid item>
                          <Link
                            href={detail.review_url}
                            target="_blank"
                            rel="noreferrer"
                            color="inherit"
                            underline="hover">
                            <Typography variant="subtitle1">{`${detail.review_count} reviews`}</Typography>
                          </Link>
                        </Grid>
                      )}
                    </Grid>
                  ) : (
                    <Typography>No reviews</Typography>
                  )}
                   <Grid item xs={2} display="flex" justifyContent="flex-end">
                    <EditProductLinks
                      provider={detail}
                      fetchData={fetchProduct}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                    <DeleteProductProvider
                    detail={detail}
                    fetchData={fetchProduct}
                    token={token}
                    setMessage={setMessage}
                    setSnackbarOpen={setSnackbarOpen}
                  />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          ))
        ) : (
          <Typography
            sx={{ textAlign: 'center' }}
            variant="caption"
            component="p">
            You can add buying options here
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductProvider;
